import React, { useContext } from 'react'
import './Intro.css'
import FloatingDiv from '../FloatingDiv/FloatingDiv';

import Github from '../../img/github.png';
import LinkedIn from'../../img/linkedin.png';
import Instagram from'../../img/instagram.png';
// import Vector1 from  '../../img/Vector1.png';
// import Vector2 from '../../img/Vector2.png';
import Logo from '../../img/logo.png';
import thumbup from '../../img/thumbup.png';
import Crown from '../../img/crown.png';
import glassesimoji from '../../img/glassesimoji.png';
import {themeContext} from '../../Context';
import {motion} from 'framer-motion'
import { Link } from 'react-scroll';



const Intro = () => {
  const transition={duration : 2,type: 'spring'}
const theme=useContext(themeContext);
const darkMode=theme.state.darkMode;
    return (
  <div className="intro">
    <div className="i-left">
        <div className="i-name">
      <span style={{color:darkMode?'white':''}}>Hi </span>
       <span>Sushmita Majumder</span>
       <span>Welcome to my Portfolio Website.I am pursuing <br/>B Tech from "ICFAI UNIVERSITY TRIPURA". Currently Working with MERN STACK Development in ONGC.</span></div>
       <Link spy={true} to='Contact'>
         <button className="button">Hire Me</button>
        </Link> 
  
    <div className="i-icons">
        <a href="https://github.com/binarybeauty45" target="_blank">
          <img src={Github}  alt="" className='icon'/></a>
        <a href="https://www.linkedin.com/in/binarybeauty45/" target="_blank">
        <img src={LinkedIn} alt=""  className='icon'/></a>
        <a href="https://www.instagram.com/riyasm78/" target="_blank">
         <img src={Instagram} alt=""  className='icon'/></a>
        
   

    </div>
    
    
    </div>
     <div className="i-right">
       
        <img style={{border: '1px solid aqua', borderRadius: '10%'}} src={Logo} alt=""/>
        <motion.img
           initial={{left:'-36%'}}
          whileInView={{left:'-24%'}}
          transition={transition}
         src={glassesimoji} alt=""/>


        <motion.div
        initial={{top:'-4%',left:'74%'}}
        whileInView={{left:'48%'}}
        transition={transition}
         style={{top:'-8%',left:'48%'}} className='floatingdiv'>
          <FloatingDiv image={Crown} txt1='Web' txt2='Developer'/>
        
        
        </motion.div>
        <motion.div 
        initial={{left:'9rem',top:'18rem'}}
        whileInView={{left:'0rem'}}
        
        style={{top:'18rem' , left:'29%'}} className='floatingdiv'>
          <FloatingDiv image={thumbup} txt1=''txt2='Focussed'/>
        </motion.div>
    
    <div className='blur' style={{background:"rgb(238 210 255)"}}></div>
    <div className='blur' style={{background:'#C1F5FF',top:'17rem',width:'21rem',height:'11rem',left:'-9rem'}}></div>
    
    
    </div>

  </div>



    )}
    export default Intro